import { ChangeDetectorRef, Component, Inject, Input, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { UserStoreService } from "../../../services/state-management/user-store.service";
import { Kaza, User } from "@adeo/ngx-kozikaza-api";
import { Observable } from "rxjs/internal/Observable";
import { tap } from "rxjs/operators";
import { KzIconsRegistryService } from "../../../../kz-ui/ui/icon/kz-icons-registry.service";
import { kzIconsCross } from "../../../../kz-ui/ui/icon/generated-icons/kzIcons-cross.icon";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { of } from "rxjs/internal/observable/of";
import { DateService } from "../../../services/utilities/date.service";
import { isPlatformBrowser } from '@angular/common';
import { DasService } from "../das.service";
import { CookieService } from 'ngx-cookie';

@Component({
  selector: 'app-da',
  host: {
    '[class]': '"app-da"',
  },
  template: `
    <div class="app-da-container" [ngStyle]="{ 'bottom.rem': adYOffset}"  [@adAnimation] *ngIf="adTransition === 'slideUp' && !!adId  && (displayAd$ | async) && !hideForeverAd"><ng-container *ngTemplateOutlet="daContent"></ng-container></div>
    <div class="app-da-container" [ngStyle]="{ 'bottom.rem': adYOffset}" [@fade] *ngIf="adTransition === 'none' && !!adId  && (displayAd$ | async) && !hideForeverAd"><ng-container *ngTemplateOutlet="daContent"></ng-container></div>
    <ng-template #daContent>
      <button (click)="close()"
              [appGtmTrack]="areaId + '_croix'" [trackAdId]="adId" [trackPartnerId]="partnerId" class="kz-button--close"><kz-icons name="cross"></kz-icons></button>
      <div [appGtmTrack]="areaId" [trackAdId]="adId" [trackPartnerId]="partnerId" >
        <ng-content></ng-content>
      </div>
    </ng-template>
    <img *ngIf="showCloseTrackingPixel" [src]="closeTrackingPixel" style="display: none">
    <img *ngIf="showNoMoreTrackingPixel" [src]="noMoreTrackingPixel" style="display: none">`,
  styleUrls: ['./da.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fade', [
      state('void', style({ opacity: 0 })),
      state('*', style({ opacity: 1 })),
      transition(':enter, :leave', [
        animate(1000)
      ])
    ]),
    trigger('adAnimation', [
      transition(':enter', [
        style({opacity: 0.5, transform: 'translateY(120%)'}),
        animate('{{time}} {{delay}} ease-in-out', style({ opacity: 1, transform: 'translateY(0%)' }))
      ], {params: {time: '1000ms', delay: '0ms'}}),
      transition(':leave', [
        animate('{{timeLeave}} {{delayLeave}} ease-in-out', style({ opacity: 0.5, transform: 'translateY(120%)' }))
      ], {params: {timeLeave: '1000ms', delayLeave: '0ms'}}),
    ])
  ],

})
export class DaComponent implements OnInit {

  public displayAd$: Observable<boolean>;
  public hideForeverAd = false;

  // Required
  @Input() adId!: string;
  @Input() partnerId!: string;
  @Input() areaId!: string;

  @Input() closeTrackingPixel: string;
  @Input() noMoreTrackingPixel: string;
  @Input() adTransition: 'none' | 'slideUp' = 'none';
  @Input() adYOffset: number | null = null;
  showCloseTrackingPixel = false;
  showNoMoreTrackingPixel = false;

  @Input() userCriteriaCallback: (user: User, kaza: Kaza) => boolean = () => { return true;};

  constructor(
    private readonly userStoreService: UserStoreService,
    private readonly cdr: ChangeDetectorRef,
    private readonly kzIconsRegistryService: KzIconsRegistryService,
    private readonly cookieService: CookieService,
    private readonly dateService: DateService,
    private readonly dasService: DasService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
  }

  close() {
    this.hideForeverAd = true;
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.cookieService.get('kzkz_divide_delay_by')) {
        this.dasService.delayBeforeOpeningAd = this.dasService.delayBeforeOpeningAd / parseInt(this.cookieService.get('kzkz_divide_delay_by'));
      }

      if (!!this.adId) {
        this.kzIconsRegistryService.registerIcons([kzIconsCross]);
      }
      this.displayAd$ = this.dasService.setCurrentAdComponentObs(this)
        .pipe(
          tap((a) => this.cdr.detectChanges()),
        )
    } else {
      this.displayAd$ = of(false);
    }
  }

}
